﻿angular.module('projectModule')
    .service('ntaMeasureData',
        ['$log', 'ntaData', 'ntaSharedLogic', 'ntaEntityDataOrg',
function ($log,   ntaData,   ntaSharedLogic,   ntaEntityDataOrg) {
    'use strict';
    const self = this;

    /// == Imports ================================================================================


    /// == Instance variables =====================================================================

    const _begrVlaktypeByMeasureType = new Map(Object.entries({
        'MEASURE-RC_VLOER': 'VLAK_VLOER',
        'MEASURE-RC_VLOER_BOVBUI': 'VLAK_VLOER_BOVBUI',
        'MEASURE-RC_GEVEL': 'VLAK_GEVEL',
        'MEASURE-RC_DAK': 'VLAK_DAK',
        'MEASURE-RC_KELDERWAND': 'VLAK_KELDERW',
        'MEASURE-RC_BODEM': 'VLAK_VLOER', // TODO: welke begrenzingen tonen voor de bodem-Rc?
    }));

    const _measureTypesByBegrVlaktype = [..._begrVlaktypeByMeasureType]
        .reduce((map, [measureType, begrVlaktype]) => {
            const set = map.get(begrVlaktype) || new Set();
            map.set(begrVlaktype, set);
            set.add(measureType);
            return map;
        }, new Map());

    const _collator = new Intl.Collator('nl-NL', { sensitivity: 'accent' });

    /// == Exports ================================================================================

    Object.assign(self, {
        // -- fields --
        begrVlaktypeByMeasureType: _begrVlaktypeByMeasureType,
        measureTypesByBegrVlaktype: _measureTypesByBegrVlaktype,

        // -- methods --
        getList,
        getTypes,
        getPropMeasureType,
        getName,
        getDefaultName,
        getMeasureRcsForBegrVlaktype,
        getBegrenzingByUniqueBegrenzing,
        checkBegrRelations,
        isItemChecked,
        toggleItemChecked,
        sortMeasuresByName,
    });


    /// == Initialization =========================================================================
    sortMeasuresByName();

    /// == Implementation =========================================================================

    function getList() {
        return ntaData.original.getListWithEntityId('MEASURE');
    } //-- end: getList ---------------------------------------------------------------------------

    function getTypes() {
        const propMeasureType = getPropMeasureType();
        const types = propMeasureType?.Domain.Codes || [];
        return types && ntaSharedLogic.isUtiliteit() ? types : types.filter(x => x.Id !== 'MEASURE-VERL');
    } //-- end: getMeasureTypes -------------------------------------------------------------------

    function getPropMeasureType() {
        // Deze moeten we dynamisch ophalen, want we kunnen switchen van en naar berekeningen
        //  in een versie die deze property überhaupt niet kent.
        return ntaData.properties["MEASURE_TYPE"];
    } //-- end: getPropMeasureType ----------------------------------------------------------------

    function sortMeasuresByName() {
        const indexByTypeId = new Map();
        getTypes().forEach((type, index) => {
            indexByTypeId.set(type.Id, index);
        });

        const orderMeasures = (a, b) => {
            const aIndex = indexByTypeId.get(a.PropertyDatas['MEASURE_TYPE'].Value) ?? Number.MAX_SAFE_INTEGER;
            const bIndex = indexByTypeId.get(b.PropertyDatas['MEASURE_TYPE'].Value) ?? Number.MAX_SAFE_INTEGER;

            return aIndex - bIndex
                || _collator.compare(a.PropertyDatas['MEASURE_NAAM'].Value, b.PropertyDatas['MEASURE_NAAM'].Value)
                || a.Order - b.Order;
        }; //-- end: orderMeasures --

        const measures = getList().sort(orderMeasures);

        ///opslaan op de server
        ntaEntityDataOrg.SaveReOrder(measures);

        return measures;
    } //-- end: sortMeasuresByName ----------------------------------------------------------------

    function getName(measure) {
        return measure.PropertyDatas['MEASURE_NAAM'].Value;
    } //-- end: getName ---------------------------------------------------------------------------

    function getDefaultName(measureTypeIdOrEntdata) {
        const propMeasureType = getPropMeasureType();
        const [measureTypeId, entdata] = typeof measureTypeIdOrEntdata === 'string'
            ? [measureTypeIdOrEntdata, null]
            : [propMeasureType.getValue(measureTypeIdOrEntdata), measureTypeIdOrEntdata];

        const measureType = propMeasureType.Domain.Codes.find(code => code.Id === measureTypeId);
        const defaultName = measureType && htmlDecode(measureType.Value) || '';

        const measureNames = new Set(
            getList()
                .filter(ed => ed !== entdata)
                .map(ed => ed.PropertyDatas['MEASURE_NAAM'].Value)
        );
        let counter = 1;
        let name;
        do {
            name = defaultName + ' ' + counter++;
        } while (measureNames.has(name));

        return name;
    } //-- end: getDefaultName --------------------------------------------------------------------

    function htmlDecode(text) {
        if (!text) return text;
        const span = document.createElement('span');
        span.innerHTML = text;
        return span.innerText;
    } //-- end: htmlDecode ------------------------------------------------------------------------

    function getMeasureRcsForBegrVlaktype(begrVlaktype) {
        const measureTypeIds = _measureTypesByBegrVlaktype.get(begrVlaktype);
        return getList()
            .filter(ed => measureTypeIds.has(ed.PropertyDatas['MEASURE_TYPE'].Value))
            .map(ed => ntaData.original.getFirstChild(ed, 'MEASURE-RC'));
    } //-- end: getMeasureRcsForBegrVlaktype ------------------------------------------------------


    function getBegrenzingByUniqueBegrenzing(begrenzingen, begrenzingLogic) {
        //benodige gegevens:    Id: unieke begrenzing,
        //                      Value: unieke begrenzing,
        // toevoeging list met EntitydataIds of Begrenzingen
        const result = [];
        const propVlak = ntaData.properties['BEGR_VLAK'];
        for (const begrenzing of begrenzingen) {
            const vlak = propVlak.getValue(begrenzing);
            const propId = ntaSharedLogic.getBegrenzingPropId(begrenzing);
            const propBegr = ntaData.properties[propId];
            if (!propBegr) continue;
            const orientatie = propBegr.getValue(begrenzing);
            const existingItem = result.find(x => x.Id === orientatie);
            if (existingItem) {
                existingItem.entdatas.push(begrenzing);
            } else {
                const vlakCode = propVlak.Domain.Codes.find(x => x.Id === vlak);
                const vlakValue = vlakCode?.Value || "";

                const codedValues = begrenzingLogic.getCodedValues(propBegr, begrenzing);

                const orientatieCode = codedValues.find(x => x.Id === orientatie);
                const orientatieValue = orientatieCode?.Value || "";
                result.push({ Id: orientatie, Value: vlakValue + " - " + orientatieValue, entdatas: [begrenzing] });
            }
        }
        return result;
    } //-- end: getBegrenzingByUniqueBegrenzing ---------------------------------------------------

    function checkBegrRelations(prop, specificMeasure, items) {
        //controleer per item of de relaties tussen begr en specificMeasure goed zijn.
        for (const item of items) {
            for (const begr of item.entdatas) {
                const relations = ntaEntityDataOrg.getRelationsBetween(begr, specificMeasure);
                if (isItemChecked(prop, specificMeasure, item)) {
                    if (relations.length === 0) { // relatie toevoegen
                        ntaEntityDataOrg.createRelation(begr.EntityDataId, specificMeasure.EntityDataId, false, false);
                    }
                } else {
                    for (const relation of relations) { // relatie verwijderen (als er een relatie is)
                        ntaEntityDataOrg.deleteRelation(relation.EntityRelationDataId);
                    }
                }
            }
        }

        //controleer of de bestaande relaties met begrenzingen wel beschikbaar zijn -> anders verwijderen. Zie https://trello.com/c/rEOQ926j/1441-melding-dat-maatregel-niet-kan-worden-toegevoegd-aan-variant
        const availableBegrenzingen = new Set(items.flatMap(item => item.entdatas).flatMap(ed => ed.EntityDataId));
        const relations = ntaEntityDataOrg.getParentRelations(specificMeasure, 'BEGR');
        const relationsToDelete = relations.filter(rel => !availableBegrenzingen.has(rel.Parent));
        for (const relation of relationsToDelete) {
            ntaEntityDataOrg.deleteRelation(relation.EntityRelationDataId);
        }

    } //-- end: checkBegrRelations ----------------------------------------------------------

    function isItemChecked(prop, specificMeasure, item) {
        if (!prop || !specificMeasure || !item)
            return false;
        const itemIds = getItemIds(prop, specificMeasure);
        return itemIds.has(item.Id);
    } //-- end: isItemChecked ---------------------------------------------------------------------

    function getItemIds(prop, entdata) {
        return new Set(String(prop.getValue(entdata) ?? '').split('|').filter(v => v));
    } //-- end: getItemValues ---------------------------------------------------------------------

    function toggleItemChecked(prop, specificMeasure, item) {
        // Eerst opslaan, want bij het toevoegen/verwijderen van relaties wordt de measure gevalideerd en de totale kosten bepaald.
        const propdata = prop.getData(specificMeasure);
        const itemIds = getItemIds(prop, specificMeasure);
        const wasChecked = itemIds.has(item.Id);
        if (wasChecked) {
            itemIds.delete(item.Id);
        } else {
            itemIds.add(item.Id);
        }
        const newValue = [...itemIds].join('|');
        ntaEntityDataOrg.saveprop(propdata, newValue);

        if (wasChecked) {
            // relatie(s) verwijderen
            for (const begr of item.entdatas) {
                const relations = ntaEntityDataOrg.getRelationsBetween(begr, specificMeasure);
                for (const relation of relations) {
                    ntaEntityDataOrg.deleteRelation(relation.EntityRelationDataId);
                }
            }
        } else {
            // relatie(s) aanmaken
            for (const begr of item.entdatas) {
                ntaEntityDataOrg.createRelation(begr.EntityDataId, specificMeasure.EntityDataId, false, false);
            }
        }

        return !wasChecked;
    } //-- end: toggleItemChecked -----------------------------------------------------------------


}]); //== end: ntaMeasureData =====================================================================


angular.module('projectModule')
    .service('ntaMeasure',
        ['$log', 'ntaMeasureData', 'ntaEntityDataOrg', 'ntaData', 'ntaSharedLogic', 'ListCache', 'ntaMeldingen', 'ntaDependencyValidation',
function ($log,   ntaMeasureData,   ntaEntityDataOrg,   ntaData,   ntaSharedLogic,   ListCache,   ntaMeldingen,   ntaDependencyValidation) {
    'use strict';
    const self = this;

    /// == Imports ================================================================================

    const getList = ntaMeasureData.getList;
    const getTypes = ntaMeasureData.getTypes;
    const getPropMeasureType = ntaMeasureData.getPropMeasureType;
    const getName = ntaMeasureData.getName;
    const getDefaultName = ntaMeasureData.getDefaultName;
    const sortMeasuresByName = ntaMeasureData.sortMeasuresByName;


    /// == Instance variables =====================================================================

    const _currency = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const _listCache = new ListCache();

    // Per maatregeltype, de propertyId waar de begrenzingen in zitten
    const _begrPropIdPerSpecificMeasureEntityId = new Map(Object.entries({
        "MEASURE-RC":   'MEASURE-RC_BEGR_IDS',
        "MEASURE-U":    'MEASURE-U_BEGR_IDS',
        "MEASURE-ZONW": 'MEASURE-ZONW_BEGR_IDS',
    }));

    // Alle velden waar incl/excl BTW aan de naam toegevoegd moet worden
    const _vatPropIds = new Set([
        'MEASURE-RC_KOSTEN_PER_M2', 'MEASURE-RC_KOSTEN_TOT',                        // [RC-H]
        'MEASURE-U_KOSTEN_PER_M2', 'MEASURE-U_KOSTEN_TOT',                          // [U-N]
        'MEASURE-ZONW_KOSTEN_PER_M2', 'MEASURE-ZONW_KOSTEN_TOT',                    // [ZON-F]
        'INFIL_KOSTEN_TOT',                                                         // [INF-G]
        'VLEIDING_KOSTEN_TOT',                                                      // [VERTI-B]
        'MEASURE-COSTS_PER_SYS', 'MEASURE-COSTS_PER_M2', 'MEASURE-COSTS_TOTAAL',    // [PV-D], [HVAC-D], [WI-B], [VERL-B]
    ]);


    /// == Exports ================================================================================

    Object.assign(self, {
        // -- methods --
        create,
        copy,
        delete: remove,
        getList,
        getTypes,
        getName,
        getDefaultName,
        getTileDetails,
        canHaveSubmeasures,
        sortMeasuresByName,
        getSubmeasures,

        setBtwPropIds,
        getPropVatText,
        getVatText,

        getLogic,
    });


    /// == Initialization =========================================================================



    /// == Implementation =========================================================================

    function create(measureTypeId) {
        const measureId = ntaEntityDataOrg.create('MEASURE', -1, [], [], [
            { PropertyId: 'MEASURE_TYPE', Value: measureTypeId },
            { PropertyId: 'MEASURE_NAAM', Value: getDefaultName(measureTypeId) },
        ]);
        const measure = ntaEntityDataOrg.get(measureId);

        const propMeasureType = getPropMeasureType();
        const measureType = propMeasureType.getCode(measure);
        const specificEntityId = measureType && measureType.FilterValue1;
        if (ntaData.entities[specificEntityId]) {
            const newId = ntaEntityDataOrg.create(specificEntityId, -1, [{ "OnCopy": 1, "OnDelete": 1, "Parent": measureId, "ParentEntityId": measure.EntityId }], [], []);
            const specificMeasure = ntaEntityDataOrg.get(newId);

            const begrPropId = _begrPropIdPerSpecificMeasureEntityId.get(specificEntityId);
            if (begrPropId) {
                selectAllBegrenzingen(specificMeasure, measure, begrPropId);
            }

        } else {
            $log.error(propMeasureType.getValue(measure), ' is (nog) niet gedefinieerd!');
        }

        ntaMeasureData.sortMeasuresByName();

        return measure;
    } //-- end: create ----------------------------------------------------------------------------

    function copy(id) {
        const newEntdatas = ntaEntityDataOrg.copy(id);

        ntaMeasureData.sortMeasuresByName();

        return newEntdatas;
    } //-- end: copy --------------------------------------------------------------------------------//

    function remove(measure) {
        ntaEntityDataOrg.delete(measure.EntityDataId);

        const meldingen = ntaMeldingen.getMeldingen()
            .filter(ed => {
                const propdata = ed.PropertyDatas['MELD_SHADOWID'];
                return propdata && propdata.Value === measure.EntityDataId;
            });
        for (const melding of meldingen) {
            ntaMeldingen.delete(melding);
        }

        ntaMeasureData.sortMeasuresByName();
    } //-- end: remove ----------------------------------------------------------------------------

    function canHaveSubmeasures(measure) {
        const logic = getLogic(measure);
        return logic && (typeof logic.canHaveSubmeasures === 'function' ? logic.canHaveSubmeasures(measure) : logic.canHaveSubmeasures) || false;
    } //-- end: canHaveSubmeasures ----------------------------------------------------------------

    function getSubmeasures(measure) {
        const logic = getLogic(measure);
        const submeasures = logic && logic.getSubmeasures && logic.getSubmeasures(measure) || [];
        return _listCache.useCacheIfUnchanged('submeasures:' + measure.EntityDataId, submeasures, (a, b) => a.id === b.id && a.name === b.name && a.icon === b.icon);
    } //-- end: getSubmeasures --------------------------------------------------------------------

    function setBtwPropIds(ctrl) {
        const vatSuffix = getVatText();
        for (const propId of _vatPropIds) {
            ctrl.nameSuffixByPropId.set(propId, vatSuffix);
        }
    } //-- end: setBtwPropIds ---------------------------------------------------------------------

    function getPropVatText(prop) {
        return _vatPropIds.has(prop.Id) ? getVatText() : '';
    } //-- end: getPropVatText --------------------------------------------------------------------

    function getVatText() {
        return (ntaSharedLogic.isUtiliteit() ? 'excl.' : 'incl.') + ' BTW';
    } //-- end: getPropVatText --------------------------------------------------------------------

    function getLogic(measureOrId) {
        return ntaDependencyValidation.getMeasureLogic(measureOrId);
    } //-- end: getLogic --------------------------------------------------------------------------

    function getTileDetails(measure) {
        const measureType = getPropMeasureType().getCode(measure);
        const specificMeasure = ntaEntityDataOrg.getFirstChild(measure, measureType.FilterValue1);

        const logic = getLogic(measure);
        let lines = [];
        if (logic && logic.getTileDetails) {
            const renderer = {
                detail: renderDetail,
                value: renderValue,
                propValue: renderPropValue,
            };
            lines = logic.getTileDetails(renderer);
        } else {
            lines.push({ name: measureType.Value });
        }

        return _listCache.useCacheIfUnchanged(measure.EntityDataId, lines, (a, b) => a.name === b.name && a.value === b.value);

        // -- hulpfuncties --
        function renderDetail(propdataOrId, entdata = specificMeasure) {
            const propdata = getPropdata(propdataOrId, entdata);
            const prop = ntaData.properties[propdata.PropertyId];
            return {
                name: prop.Name,
                value: renderValue(propdata),
            };
        }

        function renderValue(propdataOrId, entdata = specificMeasure) {
            const propdata = getPropdata(propdataOrId, entdata);
            const prop = ntaData.properties[propdata.PropertyId];
            const code = prop.getCode(ntaEntityDataOrg.get(propdata.EntityDataId));
            const value = code && code.Value || propdata.Value;
            return renderPropValue(prop, value);
        }

        function renderPropValue(propOrId, value) {
            const prop = typeof propOrId === 'string' ? ntaData.properties[propOrId] : propOrId;
            if (value === undefined) {
                return value;
            } else if (prop.Unit === '€') {
                return value !== null
                    ? prop.Unit + ' ' + _currency.format(ntaSharedLogic.parseFloat(value))
                    : prop.Unit + ' --';
            } else if (value === null) {
                value = '--';
            }
            return value + ' ' + (prop.Unit || '');
        }

        function getPropdata(propdataOrId, entdata = specificMeasure) {
            return typeof propdataOrId === 'string'
                ? entdata.PropertyDatas[propdataOrId]
                : propdataOrId;
        }
    } //-- end: getTileDetails --------------------------------------------------------------------

    function selectAllBegrenzingen(specificMeasure, measure, propId) {
        const logic = getLogic(measure);
        const propBegrId = ntaData.properties[propId];
        const begrenzingItems = logic.getCodedValues(propBegrId);
        for (const begrItem of begrenzingItems) {
            ntaMeasureData.toggleItemChecked(propBegrId, specificMeasure, begrItem);
        }
    } //-- end: selectAllBegrenzingen --------------------------------------------------------------------------

}]); //== end: ntaMeasure =========================================================================
